export type Language = 'en' | 'fr';

export const languages: Language[] = ['en', 'fr'];
